const MODAL_OPEN_EVENT_NAME = 'MODAL_OPEN';
const MODAL_CLOSE_EVENT_NAME = 'MODAL_CLOSE';

export const getModalOpenEvent = (moduleInstanceId: number) => `${MODAL_OPEN_EVENT_NAME}_${moduleInstanceId}`;
export const getModalCloseEvent = (moduleInstanceId: number) => `${MODAL_CLOSE_EVENT_NAME}_${moduleInstanceId}`;
